<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <!-- 主题内容 -->
    <div class="b-center-container">
      <!-- 富文本 -->
      <div class="b-container">
        <div class="b-center-main">
          <div class="b-richtext">
            <p v-html="richText"></p>
          </div>
        </div>
      </div>
    </div>
    <v-contact></v-contact>
      <!--
      <v-footer></v-footer>
      <v-copy></v-copy>
      -->
  </div>
</template>
<script>
/* eslint-disable */
import Header from "@/components/header/";
import Nav from "@/components/nav/";
import Copy from "@/components/copy/"
import Breadcrumb from "@/components/breadcrumb/"
import Contact from "@/components/contact/";
export default {
  data () {
    return {
      richText: '',
    };
  },
  mounted () {
    this.richText = '<p style="text-align: left; "><span style="font-size: 22px; border-bottom: solid 3px #033d80;">耶鲁中心</span></p>'
      + '<p style="margin-top : 20px; margin-bottom : 40px"><span style="margin-left: 36px; font-size: 16px;">2014年3月，上海交通大学张杰校长和耶鲁大学Peter Salovery校长签署协议，宣告上海交大—耶鲁联合中心成立。作为上海交大—耶鲁中心的首个分中心，生物统计联合中心将开展生物统计相关科学研究、教育教学、科研合作项目，并负责转化医学中心和交大其他相关项目的课题设计与数据分析，中心同时在闵行校区和医学中心开展与各大高校、机构和公司的密切合作。</span></p>'

      + '<ul>'
      + '<li style="margin-left: 80px; font-size: 18px; color: #033d80;">▶ 科学研究</li>'
      + '<li style="margin-left: 80px; margin-bottom : 30px;font-size: 16px;">上海交大—耶鲁生物统计联合中心将招聘世界一流的生物统计学家，力求在生物统计和转化医学相关领域聚集一批世界顶尖的学术力量。具体领域包括临床试验，统计基因组学，流行病学，影像分析，实效研究，因果推断，计算生物学，医疗信息学等热门方向。</li>'


      + '<li style="margin-left: 80px; font-size: 18px; color: #033d80;">▶ 教育教学</li>'
      + '<li style="margin-left: 80px; margin-bottom : 30px;font-size: 16px;">联合中心将系统性地设计生物统计相关课程，旨在培养未来转化和精准医疗领域内的领军人物。中心的每一个学生将同时接受交大老师和耶鲁老师的共同指导。中心还将举办各类研讨会和短课程，内容涉及研究设计、数据分析、研究计划拟定等。中心将通过举办这些研讨会来扩展专业领域，最终建立一个综合性培养项目。</li>'

      + '<li style="margin-left: 80px; font-size: 18px; color: #033d80;">▶ 科研合作</li>'
      + '<li style="margin-left: 80px; margin-bottom : 30px;font-size: 16px;">联合中心将提供更为广泛的合作机会，推动合作单位与中心任职的统计领域专家和数据信息管理人员的交流与合作，以解决医学转化项目中的研究设计和分析难点。</li>'

      + '<li style="margin-left: 80px; font-size: 18px; color: #033d80;">▶ 交大-耶鲁交流合作</li>'
      + '<li style="margin-left: 80px; margin-bottom : 20px;font-size: 16px;">联合中心将为交大和耶鲁科研人员提供长期稳定的合作交流平台，旨在癌症，心血管，代谢病及其它重大疾病领域开展深度合作研究。</li>'

      + '</ul>'

    + '<p>&nbsp;</p>'


    //+'<p style="margin-bottom : 20px; text-align: center"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/gxsys2.png" style="width: 780px; margin-right: 16px;margin-bottom: 16px;" width="960px"  border="0" vspace="0" alt=""></p>'

  },
  components: {
    "v-header": Header,
    "v-nav": Nav,
    "v-copy": Copy,
    "v-breadcrumb": Breadcrumb,
    "v-contact": Contact,
  }
};
</script>
<style lang="scss">
  @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
    .b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
    }
  }
.b-richtext {
  text-align:left;
  b,
  strong {
    font-weight: 700;
  }
  p {
    margin: 0 0 10px;
    line-height: 32px;
  }
  line-height: 32px;
}
</style>



// WEBPACK FOOTER //
// src/pages/yale/index.vue